import { ASSIGNAPPROVERS_SUCCESS, ASSIGNAPPROVERS_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const assignApproversReducer = (state = initialState, action) => {
    switch (action.type) {
        case ASSIGNAPPROVERS_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case ASSIGNAPPROVERS_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default assignApproversReducer;
